function number(value: any) {
    const parsed = Number(value || 0);
    return Number.isFinite(parsed) ? parsed : 0;
}

function list(value: any) {
    return Array.isArray(value) ? value : [];
}

function recycleActions(cycle: any, totalQuantity: number) {
    const storedLevels = list(cycle?.recycle_levels);
    const levels = storedLevels.length > 0
        ? storedLevels
        : totalQuantity > 0
            ? [{
                stage: 0,
                quantity: totalQuantity,
                price: number(cycle?.recycle_target_price)
            }]
            : [];
    return levels
        .filter((level: any) => number(level?.quantity) > 0)
        .map((level: any) => {
            const stage = Math.max(0, number(level?.stage));
            const price = Math.max(0, number(level?.price));
            return {
                kind: 'recycle-sell',
                label: stage > 0
                    ? `${stage}차 재매수분 매도`
                    : '재매수분 매도',
                price,
                value: price > 0 ? '' : '매도가 확인 중',
                detail: `${Math.max(0, number(level?.quantity))}주`
            };
        });
}

function rebuyAction(
    rebuyCount: number,
    openSlots: number,
    touchedSlots: number
) {
    if (openSlots <= 0) return null;
    const untouchedSlots = Math.max(0, openSlots - touchedSlots);
    return {
        kind: 'rebuy',
        label: openSlots === 1
            ? `${rebuyCount + 1}차 재매수`
            : `재매수 조건 ${openSlots}개`,
        price: 0,
        value: touchedSlots > 0
            ? untouchedSlots > 0
                ? `반등 ${touchedSlots} · 하락 ${untouchedSlots}`
                : '반등 확인 중'
            : '하락 확인 중',
        detail: touchedSlots > 0
            ? '실시간 저점 기준'
            : '매도한 수량 범위'
    };
}

export function buildCycleActions(cycle: any, nextAdd: any, nextTarget: any) {
    const rebuyCount = Math.max(0, number(cycle?.rebuy_count));
    const rebuyLimit = Math.max(0, number(cycle?.rebuy_limit));
    const rebuyOpenSlots = Math.max(0, number(cycle?.rebuy_open_slots));
    const rebuyTouchedSlots = Math.min(
        rebuyOpenSlots,
        Math.max(0, number(cycle?.rebuy_touched_slots))
    );
    const recycleQuantity = Math.max(0, number(cycle?.recycle_quantity));
    const recycle = recycleActions(cycle, recycleQuantity);
    const rebuy = rebuyAction(rebuyCount, rebuyOpenSlots, rebuyTouchedSlots);
    const auxiliaryActions = [
        ...(cycle?.continuous_add ? [] : recycle),
        ...(rebuy ? [rebuy] : [])
    ];
    const hasRebuyAction = !!rebuy;
    const hasRecycleAction = recycle.length > 0;
    return {
        rebuyCount,
        rebuyLimit,
        rebuyOpenSlots,
        rebuyTouchedSlots,
        recycleQuantity,
        auxiliaryActions,
        hasRebuyAction,
        hasRecycleAction,
        hasBuyCondition: (!!nextAdd && nextAdd.status !== 'WAITING_TIME') || hasRebuyAction,
        hasSellCondition: !!nextTarget || hasRecycleAction
    };
}
